import React from 'react';
import {useTranslation} from 'react-i18next';
import {Check} from '../icons';
import './LearningProfilePicker.scss';

// El perfil de «Aprende Dashbo» que el Admin elige al invitar (contrato §3 de la tanda
// 2026-10-03-aprende-dashbo). Viaja en `invitation/send` como `learning_roles` SÓLO si quien invita
// tocó el selector (lo decide `InviteUserForm`), y el backend lo aplica como elegido cuando la persona
// entra. Ordena lo que se le enseña; ella lo puede cambiar después.
//
// Las opciones son combinables y usan las mismas etiquetas que la página (`learn_dashbo.profile.*`).
// «Liderazgo» sólo se ofrece al invitar un Admin, y viene preseleccionado: la pista de liderazgo no
// se le muestra a quien no es Admin, porque sus tareas no las puede hacer (catálogo, «Pistas»).

export const LEARNING_ROLES = ['media_buying', 'client_service', 'leadership'];
const LEADERSHIP = 'leadership';

/** Las opciones que tiene sentido ofrecer según el tipo de usuario que se invita. */
export function learningRoleOptions(userType) {
    return userType === 'Admin' ? LEARNING_ROLES : LEARNING_ROLES.filter((role) => role !== LEADERSHIP);
}

/** Siempre en el orden del catálogo, sin repetidos ni roles desconocidos. */
export function orderedLearningRoles(roles) {
    return LEARNING_ROLES.filter((role) => (roles || []).includes(role));
}

/** Al cambiar de tipo: un Admin arranca con Liderazgo; un Regular nunca lo tiene. */
export function learningRolesForType(roles, userType) {
    const kept = (roles || []).filter((role) => role !== LEADERSHIP);
    return orderedLearningRoles(userType === 'Admin' ? [...kept, LEADERSHIP] : kept);
}

export function LearningProfilePicker({userType, roles, onChange}) {
    const {t} = useTranslation();
    const selected = roles || [];

    const toggle = (role) => {
        const next = selected.includes(role)
            ? selected.filter((item) => item !== role)
            : [...selected, role];
        onChange(orderedLearningRoles(next));
    };

    return (
        <div className="form-row invite-learning-profile" data-testid="invite-learning-profile">
            <label id="invite-learning-profile-label">{t('invite_user.learning_profile.label')}</label>
            <span className="invite-learning-profile__help" id="invite-learning-profile-help">
                {t('invite_user.learning_profile.help')}
            </span>
            <div className="invite-learning-profile__options" role="group"
                 aria-labelledby="invite-learning-profile-label" aria-describedby="invite-learning-profile-help">
                {learningRoleOptions(userType).map((role) => {
                    const on = selected.includes(role);
                    return (
                        <button key={role} type="button" data-role={role} aria-pressed={on}
                                className={`invite-learning-profile__chip${on ? ' -on' : ''}`}
                                onClick={() => toggle(role)}>
                            {on && <Check size={13} weight="bold" aria-hidden="true"/>}
                            {t(`learn_dashbo.profile.${role}`)}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
